// DS6.1.2
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useEffect, useState } from 'react';
import c from 'classnames';
import ListCard from '../../List/ListCard';
import { ListItemButton, ListItemDiv, ListItemLink, ListItemToggle } from '../../List/ListItem';
import { isDropdownGroup } from '../helpers';
import omit from 'lodash/omit';
import s from './MenuList.scss';
const MenuList = ({ id, items, itemsFillContainerWidth = false, className, ariaLabel, 'aria-describedby': ariaDescribedby, wrappedInCard = true, renderOnSSR = false })=>{
    const [mounted, setMounted] = useState(false);
    useEffect(()=>{
        setMounted(true);
    }, []);
    // Default is to render the menu on mount, set renderOnSSR
    const waitForMount = typeof window === 'undefined' && !mounted && renderOnSSR === false;
    if (waitForMount) {
        return null;
    }
    const renderListItem = (index, props)=>{
        if (props.link || props.href) {
            var _props_link;
            const href = (_props_link = props.link) !== null && _props_link !== void 0 ? _props_link : props.href;
            return /*#__PURE__*/ React.createElement(ListItemLink, _object_spread({
                key: index,
                href: href,
                fillContainerWidth: itemsFillContainerWidth
            }, omit(props, [
                'newTag',
                'link',
                'href'
            ])));
        }
        if (props.hasOwnProperty('onChange') && props.hasOwnProperty('checked')) {
            return /*#__PURE__*/ React.createElement(ListItemToggle, _object_spread({
                variant: "main"
            }, omit(props, [
                'newTag'
            ])));
        }
        if (props.onClick) {
            return /*#__PURE__*/ React.createElement(ListItemButton, _object_spread({
                key: index,
                fillContainerWidth: itemsFillContainerWidth
            }, omit(props, [
                'newTag'
            ])));
        }
        return /*#__PURE__*/ React.createElement(ListItemDiv, _object_spread({
            key: index,
            fillContainerWidth: itemsFillContainerWidth
        }, omit(props, [
            'newTag'
        ])));
    };
    const renderList = ()=>items.map((item, index)=>{
            if (!item) {
                return null;
            }
            if (isDropdownGroup(item)) {
                return /*#__PURE__*/ React.createElement("div", {
                    key: index,
                    className: s['group']
                }, item.items.map((elm, idx)=>elm && renderListItem(idx, elm)));
            } else {
                const singleItem = item;
                return renderListItem(index, singleItem);
            }
        });
    if (!wrappedInCard) {
        return /*#__PURE__*/ React.createElement("div", {
            className: c(s['root'], className)
        }, renderList());
    }
    return /*#__PURE__*/ React.createElement(ListCard, {
        onClick: (e)=>e.stopPropagation(),
        id: id,
        className: c(s['root'], !itemsFillContainerWidth && s['content-width'], className),
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-label": ariaLabel,
        tabIndex: 0
    }, renderList());
};
MenuList.displayName = 'MenuList';
export default MenuList;

//# sourceMappingURL=MenuList.js.map